import { render, staticRenderFns } from "./WhyLinkedinModal.vue?vue&type=template&id=6bbd5c28&"
import script from "./WhyLinkedinModal.vue?vue&type=script&lang=js&"
export * from "./WhyLinkedinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WhyLinkedinModal.vue"
export default component.exports